/**
 * Katalog-Namen der Slider-Locations für Admin-Elemente im DynamicSlider (2026-09-28).
 * Lädt GET /api/sliders/locations/definitions genau EINMAL je Seitenaufruf (Admin-Route) –
 * per dynamischem Import, damit der Admin-Service nicht im Bundle der normalen Nutzer landet.
 * Fail-soft: bei Fehlern null → der Aufrufer zeigt den Location-Schlüssel.
 */
let definitionsPromise: Promise<Map<string, string>> | null = null;

export const loadSliderLocationNames = (): Promise<Map<string, string>> => {
  if (!definitionsPromise) {
    definitionsPromise = import('../../services/adminSlidersService')
      .then((m) => m.default.getLocationDefinitions())
      .then((defs) => new Map(defs.map((d) => [d.location, String(d.name ?? '').trim() || d.location])))
      .catch(() => {
        definitionsPromise = null; // nächster Versuch beim nächsten Aufruf
        return new Map<string, string>();
      });
  }
  return definitionsPromise;
};

/** Anzeigename einer Location (Katalog-Name, sonst null) */
export const loadSliderLocationName = async (location: string): Promise<string | null> => {
  const names = await loadSliderLocationNames();
  return names.get(location) ?? null;
};

/** Tests: Cache leeren */
export const resetSliderLocationNames = (): void => { definitionsPromise = null; };
